// Shown as the heading on the admissions screens. KCGS carries the school's
// full name because the school section and the women's college share it.
export const institutions = {
  kcns: 'KCNS — Nursery & Primary',
  kcgs: "Khulna Collegiate Girls' School & KCC Women's College",
  honors: 'KCCWC — Honours',
};
export const admissionState = (round, now = Date.now()) => {
  if (!round || round.active === false || round.acceptingApplications === false) return 'closed';
  if (round.opensAt && new Date(round.opensAt).getTime() > now) return 'scheduled';
  if (round.closesAt && new Date(round.closesAt).getTime() < now) return 'closed';
  return 'open';
};
export const portalLink = (institution, page = '') => `/admissions-portal${page}?institution=${encodeURIComponent(institution)}`;
